<template>
  <div>
    <slot
      name="trigger"
      :on-update="
        () => update({ ...item, id: item.approverId, status: 'approved' })
      "
    >
    </slot>
    <NoteRules ref="noteDrawer" :create-fn="handleNoteAdded" note-is-optional>
      <template v-slot:header>
        <slot name="header">{{ $tc('approved') }}</slot>
      </template>
      <template
        v-slot:actions="{
          hide: hideNoteDrawer,
          submit,
          processing: noteProcessing,
        }"
      >
        <MButton class="mr-2" :loading="noteProcessing" @click="submit">
          {{ $t('approve') }}
        </MButton>
        <MButton variant="default" @click="hideNoteDrawer">{{
          $t('cancel')
        }}</MButton>
      </template>
    </NoteRules>
  </div>
</template>
<script>
import { updateApproverApi } from '@components/approval/approval-api'
import NoteRules from '@components/note-rules/note-rules'
import { authComputed } from '@state/modules/auth'

export default {
  name: 'ApproveBtn',
  components: { NoteRules },
  props: {
    item: { type: Object, required: true },
    approvalSettings: { type: Object, required: true },
  },
  data() {
    return {
      rendorCount: 1,
      processing: false,
      formData: {},
      pendingChanges: null,
    }
  },
  computed: {
    ...authComputed,
  },
  methods: {
    update(data, forceUpdate = false) {
      if (
        data.status === 'approved' &&
        this.approvalSettings.allowAddNoteOnApprovingRejectingApproval &&
        forceUpdate === false
      ) {
        return new Promise((resolve, reject) => {
          this.pendingChanges = data
          this.$refs.noteDrawer.openForm()
          this.resolve = resolve
          this.reject = reject
        }).then(() => {
          this.$emit('refresh')
        })
      }
      return updateApproverApi(data, this.isPortalLogin).then(() =>
        this.$emit('refresh')
      )
    },
    handleNoteAdded(data) {
      return this.update({ ...data, ...this.pendingChanges }, true)
        .then((data) => {
          this.$refs.noteDrawer.closeForm()
          this.pendingChanges = null
          this.resolve(data)
        })
        .catch(() => this.reject())
    },
    hide() {
      this.$refs.mPopoverRef && this.$refs.mPopoverRef.hide()
      this.formData = {}
    },
  },
}
</script>
